import { useState } from 'react';
import useReactRouter from 'use-react-router';
import { createContainer } from 'unstated-next';

import { Maker, AuthApi, MeApi, LensesApi, Configuration, Lens, ErrorStatusApi, UpdateIsErrorCheckedRequest, GetErrorListStatusEnum, GetErrorListRequest, ColorGroupId } from 'openapi';

export default createContainer(() => {

  const [userName, setUserName] = useState<string>('');
  const [storeName, setStoreName] = useState<string>('');
  const [makers, setMakers] = useState<Maker[]>([]);
  const { history } = useReactRouter();

  const login = async (userName: string, password: string) => {
    try {
      const response = await new AuthApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
      })).authenticate({ auth: { userName, password } });
      localStorage.setItem('token', response.token);
    } catch (err) {
      throw err;
    }
  };

  const logout = async () => {
    localStorage.removeItem('token');
    setUserName('');
    setStoreName('');
    history.push('/users/login');
  };

  const loadMe = async () => {
    try {
      const response = await new MeApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getMe();

      setUserName(response.userName);
      setStoreName(response.storeName);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  }

  const loadMakers = async () => {
    try {
      const response = await new LensesApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getLenses({});

      setMakers(response);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  };

  const getStatusList = async (status: string) => {
    try {
      return await new ErrorStatusApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).getErrorList({ status } as GetErrorListRequest);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  }

  const updateErrorListChecked = async (ids: UpdateIsErrorCheckedRequest) => {
    try {
      var results = await new ErrorStatusApi(new Configuration({
        basePath: process.env.REACT_APP_API_PATH,
        accessToken: localStorage.getItem('token') as string,
      })).updateIsErrorChecked(ids);
    } catch (err) {
      if (err.status === 401) {
        history.push('/users/login');
      }
    }
  }

  const getMaker = (meganetLensMasterId: number): Maker | undefined => {
    return makers.find(maker => maker.lenses.some(lens => lens.meganetLensMasterId === meganetLensMasterId));
  };

  const getLensesByMakerCode = (makerCode: string): Lens[] => {
    const maker = makers.find(maker => maker.makerCode === makerCode);
    return maker ? maker.lenses : [];
  };

  const getLensesByMasterId = (meganetLensMasterId: number): Lens[] => {
    const maker = makers.find(maker => maker.lenses.some(lens => lens.meganetLensMasterId === meganetLensMasterId));
    return maker ? maker.lenses : [];
  };

  const getLens = (meganetLensMasterId: number): Lens | undefined => {

    var result = undefined;

    makers.forEach(maker => {
      maker.lenses.forEach(lens => {
        if (lens.meganetLensMasterId === meganetLensMasterId) {
          result = lens;
        }
      })
    })

    return result;
  };

  const getColorGroupIdsByLensMasterId = (meganetLensMasterId: number): ColorGroupId[] => {

    var result: ColorGroupId[] = [];

    makers.forEach(maker => {
      maker.lenses.forEach(lens => {
        if (lens.meganetLensMasterId === meganetLensMasterId) {
          result = lens.meganetColorGroupIds;
        }
      })
    })
    return result;
  };

  const getDefaultLensMasterId = (lensType: number): number => {
    const maker = makers.find(maker => maker.lenses.some(lens => lens.lensType === lensType));
    return maker ? maker.lenses.filter(lens => lens.lensType === lensType)[0].meganetLensMasterId : -1;
  }

  return {
    userName, storeName, makers, login, logout, loadMe, loadMakers, getMaker,
    getLens, getLensesByMakerCode, getLensesByMasterId, getDefaultLensMasterId,
    getStatusList, updateErrorListChecked, getColorGroupIdsByLensMasterId
  };
});
